<template>
<div>
    <vue-html5-editor ref="vueHtml5Editor" :content="value || ''" :auto-height="false" :height="height"></vue-html5-editor>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'

export default {
    data() {
        return {

        }
    },

    components: {

    },

    props: {
        value: String,
        height: {
            default: 300,
            type: Number,
        }
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        function1() {

        },
    },

    mounted () {

        // Removed July 2024 due to chrome 127 not supporting DomSubtreeModified
        // const el = this.$refs.vueHtml5Editor.$el
        // const content = el.querySelector(".content")
        // content.addEventListener(
        //     "DOMSubtreeModified",
        //     () => {
        //         this.$emit('input', content.innerHTML)
        //     },
        //     false
        // )

//this is done because pasting in html5-editor was not triggering changes, so this will.
    // Reference to the editor's content element
    const el = this.$refs.vueHtml5Editor.$el;
    const content = el.querySelector(".content");

    // Initialize MutationObserver
    this.observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          this.$emit('input', content.innerHTML);
        }
      }
    });

    // Start observing the content element for changes
    this.observer.observe(content, {
      childList: true,        // Observe direct children
      subtree: true,          // Observe all descendants
      characterData: true     // Observe changes to text content
    });
    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// HtmlEditor.vue?2cffd949